import React from 'react';
import { LenticMark } from '../components/LenticMark';
import { EYEBROW } from '../components/site/Band';
import { Compliance as ComplianceSection } from '../components/site/Compliance';
import { WhyNotATS } from '../components/site/WhyNotATS';
export function CompliancePage() {
  return <>
      <section className="relative w-full overflow-hidden border-b border-mist bg-bone" data-id="element-467" data-mp="17qv3z2sp0ucq">
        <div className="pointer-events-none absolute -right-40 -top-32 opacity-[0.12] lg:-right-20" data-id="element-468" data-mp="1cpodyl8ru385">
          <LenticMark size={560} title={null} data-id="element-469" data-mp="1hnzqj3qgaru2" />
        </div>

        <div className="relative mx-auto w-full max-w-6xl px-6 py-24 lg:px-10 lg:py-32" data-id="element-470" data-mp="1hqlw4xts6x9n">
          <p className={`${EYEBROW} text-teal`} data-id="element-471" data-mp="1modmhnes2bbq">Compliance</p>
          <h1 className="mt-5 max-w-3xl font-display text-[32px] font-light leading-[1.05] tracking-tight text-ink sm:text-[46px] lg:text-[56px]" data-id="element-472" data-mp="1qph0s5h6fzau">
            What we capture, what we never capture, and who decides.
          </h1>
          <p className="mt-7 max-w-[68ch] text-lg leading-relaxed text-graphite" data-id="element-473" data-mp="3sgu78yysmf90">
            Lentic is designed around the evidence an employer may need when AI
            is involved in an employment decision, and around the independence
            that evidence has to have to be worth anything.
          </p>
        </div>
      </section>

      <ComplianceSection data-id="element-474" data-mp="1k9grsjirs40a" />
      <WhyNotATS data-id="element-475" data-mp="1ka9pyw3nxl6t" />
    </>;
}